import { useCallback, useState, useEffect } from 'react'
import BlobToImage from './BlobToImage.js';
import DropBox from './DropBox.js'

export const Wrapper = ({ images, onFileSelect, onImageDelete } = {}) => {
  const [droppedFiles, setDroppedFiles] = useState([]);

  const handleFileDrop = useCallback(
    (item) => {
      if (item) {
        // commented multiple load
        // const files = item.files
        const files = [item.files[0]]
        setDroppedFiles(files)
      }
    },
    [setDroppedFiles],
  )

  const handleFileClick = (e) => {
    let fileInput = document.createElement('input')
    fileInput.type = 'file'
    fileInput.accept = 'image/*'
    // commented multiple load
    // fileInput.multiple
    fileInput.click();
    fileInput.addEventListener('change', function(e) {
      setDroppedFiles([...e.target.files])
    })
  }

  useEffect(() => {
    if (droppedFiles.length) {
      onFileSelect && onFileSelect(droppedFiles[0]);
      // droppedFiles.map((img) => {
      //   console.log(123)
      //   // let reader = new FileReader();
      //   // reader.onloadend = () => {
      //   //   props.currentItem.setProductState(current => current.map((product, i) => {
      //   //     if (i === props.currentItem.selectedItemNum) {
      //   //       // commented multiple load
      //   //       // return {...product, images: [...(product?.images || []) , reader.result]};
      //   //       return {...product, images: [reader.result]};
      //   //     } else {
      //   //       return product
      //   //     }
      //   //   }))
      //   // }
      //   // reader.readAsDataURL(img)
      // })
    }
  }, [droppedFiles])

  return (
    <>
      {images?.length ?
        <BlobToImage
          files={droppedFiles}
          images={images}
          onDrop={handleFileDrop}
          onClick={handleFileClick}
          onImageDelete={onImageDelete}
        /> :
        <DropBox onDrop={handleFileDrop} onClick={handleFileClick}/>
      }
    </>
  )
}

export default Wrapper
